import { Language } from '@/interfaces'

export const de: Language = {
  home: 'Zuhause',
  about: 'Über',
  greeting: 'Willkommen in Ihrer Vue.js + TypeScript-App',
  documentation: 'Dokumentation',
  instructions:
    'Eine Anleitung und Rezepte zum Konfigurieren / Anpassen dieses Projekts finden Sie in die',
  installedPlugins: 'Installierte CLI-Plugins',
  essentialLinks: 'Wichtige Links',
  ecosystem: 'Ökosystem',
  aboutPage: 'Dies ist eine Info-Seite',
  dashboard: 'Instrumententafel',
  refreshTime: 'Zeit aktualisieren',
  inventory: 'Inventar',  
  pullInventory: 'Inventar Ziehen',
  pulls: 'Zieht',
  shipments: 'Sendungen',
  replenishments: 'Wiederauffüllungen',
  availableToPull: 'verfügbar zu ziehen',
  inProgress: 'in Bearbeitung',
  scheduledThisWeek: 'diese Woche geplant',
  search: 'Suchen..',
  shipFrom: 'Pflanze',
}
